export default __webpack_public_path__ + "static/media/m4-1.a256bca9.png";